import type { StoreApi } from "zustand";
import { requestScope } from "./scope.js";

/** Capture an action's account lifetime, including its catch/finally and post-await store writes. */
export function scopedSetter<T>(write: StoreApi<T>["setState"]) {
  const generation = requestScope().generation;
  const current = () => generation === requestScope().generation;
  return Object.assign((patch: Partial<T> | ((state: T) => Partial<T>)) => { if (current()) write(patch); }, { current });
}
